import { COUNTRY_PICKER_RECEIVE, COUNTRY_PICKER_SET_OPEN } from '../constants';

export const receive = (countryPicker) => ({
    type: COUNTRY_PICKER_RECEIVE,
    payload: countryPicker,
});

export const setOpen = (open) => ({
    type: COUNTRY_PICKER_SET_OPEN,
    payload: {
        isOpen: open,
    },
})
